// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"142":"a0d8ecb4","498":"2f9a82ae","703":"948863e1","787":"4477c348"}[chunkId] + ".chunk.js";
};